const ROLES = {
  SET_ROLES_QUERY: 'SET_ROLES_QUERY',
  SET_PERMISSION_QUERY: 'SET_PERMISSION_QUERY',
  SET_ROLESEdit: 'SET_ROLESEdit',
};

export default ROLES;
